<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 20 20"
    role="presentation"
    :fill="iconColor">
    <defs>
        <path id="aira" d="M17.393 3.49c-.681-.68-1.817-.649-2.538.072L12.39 6.199 4.563 3.856 3.242 5.177a.37.37 0 0 0 0 .524l6.345 3.493-2.492 2.704a2.648 2.648 0 0 0-.517.724l-2.649-.686-.824.824a.28.28 0 0 0 0 .396l2.915 1.478.264.264 1.479 2.915c.11.11.286.11.395 0l.824-.823-.697-2.696c.244-.12.484-.288.701-.505l2.714-2.502 3.517 6.39a.37.37 0 0 0 .524 0l1.321-1.321-2.358-7.88 2.618-2.448c.72-.72.752-1.857.071-2.537z"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="airb" fill="#fff">
            <use xlink:href="#aira"/>
        </mask>
        <use :fill="iconColor" fill-rule="nonzero" xlink:href="#aira"/>
        <g :fill="iconColor" mask="url(#airb)">
            <path d="M0 0h20v20H0z"/>
        </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: '32px'
    },
    height: {
      type: [Number, String],
      default: '32px'
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
